import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchWithAuthBaseQuery } from '../api.helpers';

import { validateAndTransformResponse } from './helpers';
import {
  hubsResourceReportResponseSchema,
  type HubsResourceReportResponse,
} from './schemas';

const paths = {
  hubsResourceReport: 'api/hubsResourceReport',
} as const;

export const hubsResourceReportApi = createApi({
  reducerPath: 'hubsResourceReportApi',
  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  keepUnusedDataFor: 50,
  // refetchOnMountOrArgChange: true,

  endpoints: build => ({
    getHubsResourceReport: build.query({
      query: () => paths.hubsResourceReport,
      transformResponse: (response: HubsResourceReportResponse) =>
        validateAndTransformResponse(
          hubsResourceReportResponseSchema,
          response,
          value => value?.location?.name,
          'hubsResourceReport',
          true,
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetHubsResourceReportQuery } = hubsResourceReportApi;
